export const RECEIVE_INVOICES = "RECEIVE_INVOICES";
export const CREATE_INVOICES = "CREATE_INVOICES";
export const REMOVE_INVOICES = "REMOVE_INVOICES";
export const FILTER_INVOICES = "FILTER_INVOICES";



// WEBPACK FOOTER //
// ./src/features/trade_documents/invoicesActionTypes.js